import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { SearchPage } from './pages/SearchPage';
import { CartPage } from './pages/CartPage';
import { WICEBTGuidePage } from './pages/WICEBTGuidePage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-slate-50" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/search" element={<SearchPage data-id="element-6" />} data-id="element-5" />
          <Route path="/cart" element={<CartPage data-id="element-8" />} data-id="element-7" />
          <Route path="/wic-ebt-guide" element={<WICEBTGuidePage data-id="element-10" />} data-id="element-9" />
        </Routes>
      </div>
    </BrowserRouter>;
}